const stepTabs = Array.from(document.querySelectorAll('.steps-item'));

if (stepTabs.length) {
  const stepPanels = Array.from(document.querySelectorAll('.steps-content'));

  const activateTab = (nextTab, shouldFocus = false) => {
    if (!nextTab) return;

    const nextIndex = nextTab.dataset.index;

    stepTabs.forEach(tab => {
      const isActive = tab === nextTab;
      tab.classList.toggle('steps-item--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    stepPanels.forEach(panel => {
      const isActive = panel.dataset.index === nextIndex;
      panel.classList.toggle('steps-content--active', isActive);
      panel.hidden = !isActive;
    });

    if (shouldFocus) {
      nextTab.focus();
    }
  };

  stepTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab));

    tab.addEventListener('keydown', event => {
      let targetIndex = index;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        targetIndex = (index + 1) % stepTabs.length;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        targetIndex = (index - 1 + stepTabs.length) % stepTabs.length;
      } else if (event.key === 'Home') {
        targetIndex = 0;
      } else if (event.key === 'End') {
        targetIndex = stepTabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      activateTab(stepTabs[targetIndex], true);
    });
  });
}
